export interface CultivationSystem {
  key: string;
  name: string;
  icon: string;
  subtitle: string;
  desc: string;
  image: string;
  points: string[];
}

export const systems: CultivationSystem[] = [
  {
    key: 'danlian',
    name: '炼丹',
    icon: 'ri-fire-fill',
    subtitle: '以丹载道 · 药火相生',
    desc: '把真气与灵药结合成丹，是医仙之路上最重要的资源型体系。从一品丹到九转金丹，每一炉丹药都对应固定的品阶与药园等级，为主角提供持续的治疗与突破支撑。',
    image:
      'https://readdy.ai/api/search-image?query=%E5%8F%A4%E9%A3%8E%E4%B8%B9%E7%82%89%E7%82%BC%E4%B8%B9%20%E9%9D%92%E7%A2%A7%E5%8F%A4%E7%81%B0%E4%B8%B9%E7%82%89%E5%8D%87%E8%85%BE%E8%8D%AF%E7%81%AB%2C%20%E7%8E%AF%E7%BB%95%E7%81%B5%E8%8D%89%E4%B8%8E%E6%9A%96%E9%87%91%E5%85%89%E6%99%95%2C%20%E5%9B%BD%E7%94%BB%E5%A2%A8%E9%9F%B5%E6%85%A2%E7%94%BB%E9%A3%8E%E6%A0%BC&width=960&height=720&seq=system-danlian-01&orientation=landscape',
    points: ['丹药品阶与灵药等级严格对应', '火候曲线：凡火→文火→灵火', '药园等级决定丹药上限'],
  },
  {
    key: 'zhenjiu',
    name: '针灸',
    icon: 'ri-node-tree',
    subtitle: '以针引气 · 通脉疗人',
    desc: '主角最核心的技能。以银针引动真气、疏通经脉，既是救人的医术，也是攻守一体的战斗手段。从聚气到医仙，针灸贯穿主角的每一条成长线。',
    image:
      'https://readdy.ai/api/search-image?query=%E9%93%B6%E9%92%88%E9%92%88%E7%81%B8%E7%BB%8F%E8%84%89%E5%85%89%E8%B7%AF%20%E7%8E%89%E9%9D%92%E7%BB%BF%E7%BB%86%E8%85%94%E8%84%89%E7%BB%9C%E4%B8%8E%E7%A9%B4%E4%BD%8D%E5%85%89%E7%82%B9%2C%20%E5%9B%BD%E7%94%BB%E5%A2%A8%E9%9F%B5%E6%85%A2%E7%94%BB%E9%A3%8E%E6%A0%BC&width=960&height=720&seq=system-zhenjiu-01&orientation=landscape',
    points: ['十二正经与奇经八脉可视化', '医武同源，救人与制敌兼备', '通脉境成为境界分水岭'],
  },
  {
    key: 'gongfa',
    name: '功法',
    icon: 'ri-sparkling-2-fill',
    subtitle: '以法筑基 · 心法驭力',
    desc: '功法决定能吸收多少真气，心法决定能驾驭多强力量。功法为器、医术为用，让主角的每一次升级都同时服务于医仙之路。',
    image:
      'https://readdy.ai/api/search-image?query=%E4%BF%AE%E7%82%BC%E5%8A%9F%E6%B3%95%E5%BF%83%E6%B3%95%20%E5%8F%A4%E9%A3%8E%E7%94%B7%E5%AD%90%E6%89%93%E5%9D%90%E5%91%A8%E8%BA%AB%E7%8E%84%E6%B0%94%2C%20%E5%9B%BD%E7%94%BB%E5%A2%A8%E9%9F%B5%E6%85%A2%E7%94%BB%E9%A3%8E%E6%A0%BC&width=960&height=720&seq=system-gongfa-01&orientation=landscape',
    points: ['境界决定功法层级', '心法同时服务炼丹与针灸', '功法为器、医术为用'],
  },
];

export interface Level {
  order: number;
  name: string;
  desc: string;
}

export const levels: Level[] = [
  { order: 1, name: '淬体境', desc: '以体筑基，打好修行与医术的根基，是医仙之路的起点。' },
  { order: 2, name: '聚气境', desc: '凝聚真气，掌握最基础的疗愈之气，开始用气行针。' },
  { order: 3, name: '通脉境', desc: '银针正式作用于经脉，从"医人"跨向"医灵"的分水岭。' },
  { order: 4, name: '丹炉境', desc: '炼丹大成，能炼出扭转伤势的灵丹，医术与修为同步跃升。' },
  { order: 5, name: '灵针境', desc: '针灸臻至化境，一针引气、救人于危，攻守一体。' },
  { order: 6, name: '医仙境', desc: '医术与修为合一，真正拥有"起死回生"的能力。' },
];